<template>
	<a-spin :spinning="!isSpin" size="large">
		<div id="DataSummary" v-if="userinfo">
			<div class="filterTask">
				<h2 style="font-size: 24px; color: #262626; font-weight: bold;">校园数据概括</h2>
				<div v-if="planlist && planlist.length">
					数据取自
					<a-select style="width: 270px" @change="taskChange" placeholder="请选择任务" :default-value="planlistOnly.title" :key="planlistOnly.title">
						<a-select-option v-for="(item, index) in planlist" :key="index + 'a'" :value="item.title" :title="item.title">{{item.title}}</a-select-option>
					</a-select>
				</div>
			</div>
			<div class="summaryBox" v-if="planlist && planlist.length">
				<div v-if="userinfo.role_id === 1" class="summaryRight summary">
					<div class="title">
						<div class="titleTop">
							<span>
								校园心理健康情况
								<a-tooltip>
									<template slot="title">当前数据看板展示了本校心理健康的整体情况。</template>
									<img src="@/assets/tags.png" alt="">
								</a-tooltip>
								<i v-if="planlistOnly">数据更新于{{planlistOnly.end_time}}</i>
							</span>
							<a @click="seeReport">查看校级报告</a>
						</div>
						<!-- <i>{{planlistOnly ? `数据更新于${planlistOnly.end_time}` : '暂无数据'}}</i> -->
					</div>
					<DATACRISIS v-if="scaleID === 993548 && reportMiddle" :dataOne="reportMiddle" :dataTwo="toughnessNumber" :total="finishedTotal" :scale="scaleID"></DATACRISIS>
					<DATACRISIS v-if="scaleID !== 993548 && reportMiddle && toughnessNumber" :dataOne="reportMiddle" :dataTwo="toughnessNumber" :total="finishedTotal" :scale="scaleID"></DATACRISIS>
				</div>
				<div class="summaryLeft summary">
					<div class="title">
						<div class="titleTop">
							<span>
								班级同伴关系图
								<a-tooltip>
									<template slot="title">学生个人的圆圈越大，表明其在班里受欢迎的程度越高。点击图中圆圈可查看学生自己所认为的好友，以及选择他/她为好友的同学。另外，您也可以点击圆圈进入学生个体心理档案。</template>
									<img src="@/assets/tags.png" alt="">
								</a-tooltip>
							</span>
							<a></a>
						</div>
					</div>
					<div class="echartsContent">
						<div class="titleBottom">
							<div>
								年级
								<a-select style="width: 120px" @change="gradeChange" placeholder="筛选年级" :default-value="gradeVal" :key="gradeVal">
									<a-select-option v-for="(item, index) in editGradeListOne" :key="index + 'a'" :value="item.name">{{item.name}}</a-select-option>
								</a-select>
							</div>
							<div>
								班级
								<a-select style="width: 120px" @change="classChange" placeholder="筛选班级" :default-value="classID" :key="classID">
									<a-select-option v-for="(item, index) in classChangeList" :key="index + 'b'" :value="item">{{item}}</a-select-option>
								</a-select>
							</div>
							<a-button class="commit" type="primary" @click="searchHandle" :disabled="!(gradeVal && classID)">查询</a-button>
						</div>
						<div class="echartsBox" v-if="gradeID && classID">
							<ECHARTSDATA ref="echartsData" :gradeId="gradeID" :classId="classID" :gradeVal="gradeVal" :classVal="classVal" :qid="planlistOnly.qid"></ECHARTSDATA>
						</div>
						<div v-else class="none" style="height: 300px">
							<img src="@/assets/echartsNone.png" alt="">
							数据采集中，敬请期待！
						</div>
					</div>
				</div>
			</div>
			<div class="noeData" v-if="!planlist">
				<img src="@/assets/noData.png" alt="">
				暂无数据
			</div>
		</div>
	</a-spin>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import URL from '@/store/url'
import GRADE from '@/util/grade.js'
import DATACRISIS from '@/components/DataCenter/DataSummary/DataCrisis'
import ECHARTSDATA from '@/components/DataCenter/DataSummary/EchartsData'
export default {
	name: 'DataSummary',
	data () {
		return {
			isSpin: true,
			scaleID: null,
			gradeID: null,
			classID: null,
			gradeVal: null,
			classVal: null,
			editGradeListOne: null,
			classChangeList: null,
			
			
			
			userinfo: null,
			planlist: null,
			planlistOnly: null
		}
	},
	computed: {
		...mapState([
			'teacherAdmin',
			// 'planlistOnly',
			'asyncFlag',
			'gradeReport',
			'finishedTotal',
			'toughnessNumber',
			'reportMiddle',
			'questionnairenTask',
			'schoolTaskList'
		])
	},
	components: {
		DATACRISIS,
		ECHARTSDATA
	},
	watch: {
		gradeID () {
      if (this.gradeID) {
				this.editGradeListOne.map(item => {
					if (item.value === this.gradeID) {
						this.classChangeList = item.class
					}
				})
      }
		}
	},
	methods: {
		...mapMutations([
			'setTaskReport'
		]),
		...mapActions([
			'getPlanlist',
			'asyncTeacherData',
			'getGradeReport',
			'SCHOOL_REPORT_993541_SCHOOL_CRISIS',
			'SCHOOL_REPORT_993541_TOUGHNESS',
			'SCHOOL_REPORT_993541_MIDDLE',
			'getQuestionnairenTask',
			'getSchoolTaskScale'
		]),
		taskChange (value) {
			this.planlistOnly = this.planlist.filter(item => value === item.title)[0]
			this.publicFun(this.planlistOnly)
		},
		gradeChange (value) {
      this.gradeID = GRADE.gradeIdTwo(value)
    },
		classChange (value) {
      this.classID = value
    },
		searchHandle () {
			this.gradeVal = GRADE.gradeName(this.gradeID)
			this.classVal = this.classID
			this.$notification.open({
        message: '数据说明',
        description: '此图数据采自本校最近一次完成的心理健康测评。图中所示的同伴关系信息属于' + this.planlistOnly.start_time + '至' + this.planlistOnly.end_time + ' “' +this.planlistOnly.title + '” ' +'中的' + this.gradeVal + this.classVal + '的数据。',
        duration: 5,
      })
			this.$refs.echartsData.search({gradeId: this.gradeID, classId: this.classID.substring(0, this.classID.length - 1), qid: this.planlistOnly.qid})
		},
		async seeReport () { // 查看报告
			if (this.scaleID) {
				await this.getGradeReport()
				if (this.gradeReport && this.gradeReport.length >= 2) {
					const url = `${URL.TO_SCHOOL_REPORT}?questionnaireId=${this.planlistOnly.qid}&school_id=${this.teacherAdmin.school_id}&endTime=${this.planlistOnly.end_time}&school_name=${this.teacherAdmin.school_name}&cityId=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&teacherUid=${this.teacherAdmin.uid}&maxGrade=${JSON.parse(sessionStorage.getItem('userInfo')).max_grade}&minGrade=${JSON.parse(sessionStorage.getItem('userInfo')).min_grade}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&starttime=${this.planlistOnly.start_time}&endtime=${this.planlistOnly.end_time}&schoolName=${this.teacherAdmin.school_name}`
					if (this.planlistOnly.finish >= 30) {
						window.open(url)
					} else {
						this.$confirm({
							title: '报告数据未满30人',
							content: '未满30人的报告数据不具有团体代表性，请谨慎参考，确定要继续查看吗？',
							okText: '继续查看',
							cancelText: '取消',
							onOk: () => {
								window.open(url)
							}
						})
					}
				} else {
					this.$warning({
						title: '提示',
						content: '贵校仅有一个年级参与并完成了最近一次心理普测任务，故无法生成校级报告。',
						okText: '我知道了'
					})
				}
			} else {
				this.$warning({
					title: '提示',
					content: '贵校还未完成最近一次心理普测任务，故无法生成校级报告。',
					okText: '我知道了'
				})
			}
		},
		async publicFun (task) {
			console.log(task)
			await this.getPlanlist()
			if (task) { // 有最新一次已结束包含危机表的任务
				let scaleIdArr = []
				let crisisT = [993541, 993544, 993548, 995000, 995002]
				task.topics.split(',').map(item => {
					if (crisisT.includes(parseInt(item))) {
						scaleIdArr.push(parseInt(item))
					}
				})
				if (scaleIdArr[0] !== 995002) {
					await this.asyncTeacherData({SID: scaleIdArr[0], DQ_ID: task.qid})
					if (!this.asyncFlag) {
						this.$message.error('更新无效数据失败')
					}
				}
				this.scaleID = (scaleIdArr[0] === 993548 ? 993548 : 993541)
				this.setTaskReport({
					qid: task.qid,
					list: scaleIdArr
				})
				// 完成总有效人数
				await this.SCHOOL_REPORT_993541_SCHOOL_CRISIS({
					scaleId: this.scaleID,
					DQ_ID: task.qid,
					endTime: task.end_time
				})
				// 症状、压力
				await this.SCHOOL_REPORT_993541_MIDDLE({
					scaleId: this.scaleID,
					DQ_ID: task.qid
				})
				if (scaleIdArr[0] !== 993548) {
					// 韧性
					await this.SCHOOL_REPORT_993541_TOUGHNESS({
						scaleId: this.scaleID,
						DQ_ID: task.qid
					})
				}
				let gradeArr = []
				let gradeArrNew = []
				if (task.classAgg && task.classAgg.length) {
					task.classAgg.map(item => {
						if (!gradeArr.includes(item.entryYear)) {
							gradeArr.push(item.entryYear)
							gradeArrNew.push({
								gradeId: item.entryYear,
								classArr: []
							})
						}
						gradeArrNew.map(value => {
							if (value.gradeId === item.entryYear) {
								if (parseInt(item.classId) !== 0) {
									value.classArr.push(item.classId + '班')
								} else {
									value.classArr = GRADE.classList
								}
							}
						})
					})
					if (this.userinfo.role_id === 3 && this.userinfo.class_list && this.userinfo.class_list.length) { // 班主任
						let classS = []
						let classList = []
						this.userinfo.class_list.map(item => {
							if (!classS.includes(item.grade_id)) {
								classS.push(item.grade_id)
								classList.push({
									gradeId: item.grade_id,
									classArr: [item.class_id + '班']
								})
							} else {
								classList.find(value => {
									if (value.gradeId === item.grade_id) {
										value.classArr.push(value.class_id + '班')
									}
								})
							}
						})
						this.editGradeListOne = GRADE.gradeTurnStr(classList)
					} else {
						this.editGradeListOne = GRADE.gradeTurnStr(gradeArrNew)
					}
					this.gradeVal = this.editGradeListOne[0].name
					this.classVal = this.editGradeListOne[0].class[0]
					this.gradeID = this.editGradeListOne[0].value
					this.classID = this.editGradeListOne[0].class[0]
				}
				this.isSpin = true
			} else {
				this.isSpin = true
			}
		}
	},
	async mounted () {
		this.userinfo = JSON.parse(sessionStorage.getItem('userInfo'))
		this.isSpin = false
		if (!this.questionnairenTask) {
      await this.getQuestionnairenTask()
    }
    if (!this.schoolTaskList) {
      await this.getSchoolTaskScale()
    }
		let crisisScale = [993541, 993544, 993548, 995000, 995002]
		let task = []
		// 教育局任务
		if (this.questionnairenTask) {
			this.questionnairenTask.map(item => {
				if (item.CHILDREN && item.CHILDREN.length)
				item.CHILDREN.map(value => {
					if (value.DQ_ID && (new Date() > new Date(value.TASK_END_DATE.replace(/-/g, '/'))) && (new Date('2022-01-01') <= new Date(value.TASK_START_DATE))) { // 满足1:任务已分发、2:任务开始时间为20220101之后，任务已经结束
						if (value.SURVEY_LIST && value.SURVEY_LIST.length) { // 3:包含危机量表
							let topics = []
							let classAgg = []
							let flag = value.SURVEY_LIST.filter(i => {return crisisScale.includes(i.SID)})
							value.SURVEY_LIST.map(item => {
								topics.push(item.SID)
							})
							value.GRADE_LIST.split(',').map(item => {
								classAgg.push({
									entryYear: parseInt(item),
									classId: '0'
								})
							})
							if (flag && flag.length) { // 包含危机表
								// 4:满足以上3点的数据
								task.push({
									qid: value.DQ_ID,
									sid: flag[0].SID,
									start_time: value.TASK_START_DATE,
									end_time: value.TASK_END_DATE,
									title: value.TASK_NAME,
									topics: topics.join(','),
									classAgg,
									finish: value.PROGRESS
								})
							}
						}
					}
				})
			})
		}
		// 单校任务
		if (this.schoolTaskList) {
			this.schoolTaskList.map(item => {
				if (item.type === 3 && (new Date() > new Date(item.end_time.replace(/-/g, '/'))) && (new Date('2022-01-01') <= new Date(item.start_time))) { // 满足1:群体分发、2:任务开始时间为20220101之后，任务已经结束
					if (item.scaleList && item.scaleList.length) { // 3:包含危机量表
						let flag = item.scaleList.filter(i => {return crisisScale.includes(i.ID)})
						if (flag && flag.length) { // 包含危机表
							// 4:满足以上3点的数据
							task.push({
								qid: item.qid,
								sid: flag[0].ID,
								start_time: item.start_time,
								end_time: item.end_time,
								title: item.title,
								topics: item.topics,
								classAgg: item.classAgg,
								finish: item.finish
							})
						}
					}
				}
			})
		}
		task.sort((a, b) => b.qid - a.qid)
		if (task && task.length) {
			if (this.userinfo.role_id === 3) {
				let banTask = []
				let bindGrade = []
				let bindClass = []
				this.userinfo.class_list.map(list => {
					bindGrade.push(list.grade_id)
					bindClass.push(list.grade_id + '' + list.class_id)
				})
				task.map(item => {
					item.classAgg.map(value => {
						if (parseInt(value.classId) === 0 && bindGrade.includes(value.entryYear)) {
							banTask.push(item)
						}
						if (parseInt(value.classId) !== 0 && bindClass.includes(value.entryYear + '' + value.classId)) {
							banTask.push(item)
						}
					})
				})
				this.planlist = [banTask[0]]
				this.planlistOnly = banTask[0]
			} else {
				this.planlist = task
				this.planlistOnly = task[0]
			}
			this.publicFun(this.planlistOnly)
		} else {
			this.isSpin = true
			this.$message.warning('系统将在测评任务结束后，更新数据')
		}
	}
}
</script>

<style scoped>
#DataSummary .noeData {
	background: #FFFFFF;
	border: 1px solid #E8E8E8;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 120px 0px;
}
#DataSummary .noeData img {
	width: 100px;
	margin-bottom: 15px;
}
#DataSummary .filterTask {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-bottom: 16px;
}
#DataSummary .summaryBox {
	margin-bottom: 100px;
}
#DataSummary .summaryBox .summary {
	background: #FFFFFF;
	border: 1px solid #E8E8E8;
}
#DataSummary .summaryBox .summary > div:nth-child(2) {
	padding: 16px 24px;
	box-sizing: border-box;
}
#DataSummary .echartsContent {
	height: 450px;
}
#DataSummary .summaryBox .summaryLeft {
	flex-basis: 63%;
	margin-top: 24px;
	margin-bottom: 24px;
}
#DataSummary .summaryBox .summaryRight {
	flex-basis: 37%;
	
}
#DataSummary .summaryBox .title {
	border-bottom: 1px solid #E8E8E8;
	padding: 16px 24px;
	box-sizing: border-box;
}
#DataSummary .summaryBox .title .titleTop, #DataSummary .summaryBox .summary .title span {
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #333333;
	font-weight: bold;
}
#DataSummary .summaryBox .title .titleTop span img {
	width: 14px;
	height: 14px;
	margin-left: 10px;
}
#DataSummary .summaryBox .title .titleTop i {
	font-weight: normal;
	margin: 0px;
	margin-left: 8px;
}
#DataSummary .summaryBox .title .titleTop a {
	font-weight: normal;
	color: #1890FF;
}
#DataSummary .summaryBox .titleBottom {
	display: flex;
}
#DataSummary .summaryBox .titleBottom > div {
	margin-right: 24px;
}
#DataSummary .summaryBox .titleBottom > div > div {
	margin-left: 16px;
}
#DataSummary .summaryBox .titleBottom button {
	margin-left: -8px;
}
#DataSummary .summaryBox .titleBottom .ant-btn-primary {
  color: #FFFFFF;
  background-color: #51BF94;
  border-color: rgba(81, 191, 148, .3);
}
#DataSummary .summaryBox .titleBottom .ant-btn-primary:hover, #DataSummary .summaryBox .titleBottom .ant-btn-primary:focus {
  border: 1px solid #51BF94;
}
#DataSummary .summaryBox .title i {
	display: inline-block;
	font-style: normal;
	color: #999999;
	font-size: 12px;
	margin-top: 8px;
	margin-bottom: 16px;
}
#DataSummary .summaryBox .summary .none {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #999999;
}
#DataSummary .summaryBox .summary .none img {
	width: 124px;
	height: auto;
	margin-bottom: 15px;
}
.echartsBox {
	padding-bottom: 0px!important;
}
.importBox {
	display: flex;
	justify-content: space-between;
}
.importBox > div {
	width: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 13px 0px;
	position: relative;
}
.importBox > div img {
	width: 43px;
	height: auto;
	margin-bottom: 21px;
}
.importBox > div span {
	font-weight: bold;
	color: #262626;
	margin-bottom: 16px;
}
.importBox > div .lines {
	position: absolute;
	right: 0px;
	top: 50%;
	transform: translateY(-50%);
	width: 1px;
	height: 60px;
	background: rgba(126,134,142,0.16);
}
</style>
